/**
 * Hook misji Loli „podaj 3 ciastka" — tylko EMIT zdarzeń (WP-V2-QC podłączy).
 * Nie implementuje serwera / QuestLayer.
 */
import type { InteractEvent } from '../../interact/index.js';
import { CAFE_QUEST_ID, isCafeCookieDef } from './objects.js';

export const INTERACT_BUS_EVENT = 'pieskowo:interact';

export type CafeMissionPayload = {
  sceneKey: 'Cafe';
  questId: typeof CAFE_QUEST_ID;
  stepKind: 'give_cookie';
  interact: InteractEvent;
};

export function isCookieGiveEvent(evt: InteractEvent): boolean {
  return evt.type === 'give' && isCafeCookieDef(evt.defId);
}

/**
 * Buduje payload misji z zdarzenia interact (give ciastka NPC/gościowi).
 * Zwraca null gdy zdarzenie nie dotyczy misji.
 */
export function cafeMissionFromInteract(evt: InteractEvent): CafeMissionPayload | null {
  if (!isCookieGiveEvent(evt)) return null;
  return {
    sceneKey: 'Cafe',
    questId: CAFE_QUEST_ID,
    stepKind: 'give_cookie',
    interact: evt,
  };
}
